/**
 * Store Landing
 */
import storeLandingPage from '../lib/store-landing-page';

storeLandingPage();
